// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Übungsauswahl als Bild-Kacheln statt Pill-Wolke (Runde 5, Muster der
// Referenz-Apps: Übungen zeigen ihr Bild, nackte Text-Tags wirken gebastelt).
import type { Exercise, PlanDayItem } from "@/lib/types"

export default function ExerciseChips({ items, exercises, selected, onSelect }: {
  items: PlanDayItem[]
  exercises: Map<string, Exercise>
  selected: string | null
  onSelect: (exerciseId: string) => void
}) {
  const selectedItem = selected ? items.find((i) => i.exercise === selected) : undefined
  return (
    <>
      <div className="extiles" aria-label="Übung wählen">
        {items.map((it) => {
          const ex = exercises.get(it.exercise)
          return (
            <button
              key={it.id}
              type="button"
              className="extile"
              aria-pressed={it.exercise === selected}
              onClick={() => onSelect(it.exercise)}
            >
              {ex?.media_slug ? (
                <img
                  src={`/media/exercises/${ex.media_slug}.jpg`}
                  alt=""
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.visibility = "hidden" }}
                />
              ) : (
                <span className="extile-blank" aria-hidden="true" />
              )}
              <b>{ex?.name ?? "Übung"}</b>
            </button>
          )
        })}
      </div>
      {selectedItem && <p className="hint">Ziel: {selectedItem.target_sets}×{selectedItem.target_reps}</p>}
    </>
  )
}
